
export const getRootContainerHeight = () => {
  return (window.innerHeight);
}